export class MaterialAction {
    _id: string;
    visitor: any;
    owner: any;
    material: any;
    actionType: string;
    actionDate: Date;
    uploadDateRange; // used for searching
    uploadStartDate: Date; // used for searching
    uploadEndDate: Date; // used for searching
    createdAt: Date;
    updatedAt: Date;  
}